import React from "react";
import "./VirasatLeftDrawer.scss"
import close from "../../assets/icons/close.svg"
import Button from "../Button/Button";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";
const VirasatLeftDrawer = ({ isOpen, setIsOpen }) => {
    const history = useHistory()
    const isComingSoon = window.location.pathname === "/coming-soon"
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "navbar")
    const linksComponent = isComingSoon ? [] : page?.Components?.find((component) => component?.ID === "VirasatV2Default-Navbar-link")?.Data ?? []
    const buttonComponent = page?.Components?.find((component) => component?.ID === "VirasatV2Default-Navbar-button")?.Props ?? null
    const dispatch = useDispatch()

    return (
        <div className="VirasatLeftDrawer">
            <div className={`Virasat-left-drawer ${isOpen ? 'open' : ''}`}>
                <div className={`Virasat-left-drawer-header`}>
                    <img alt="" src={close}
                        onClick={() => {
                            setIsOpen(false)
                        }} />
                </div>
                <div className={`Virasat-left-drawer-content`}>
                    {linksComponent.map((page, key) => {
                        return (
                            <div className={`Virasat-left-drawer-content-pages`} key={key}
                                onClick={() => {
                                    setIsOpen(false)
                                    if (page?.href?.includes("https://")) {
                                        if (page?.href && page?.href !== "") {
                                            window.open(page?.href, '_blank')
                                        }
                                        else {
                                            dispatch(setIsComing(true))

                                        }
                                    } else {
                                        history.push(page?.href)
                                    }
                                }}>
                                {page?.title}
                            </div>
                        )
                    })}
                    {buttonComponent && <div className={`Virasat-left-drawer-content-btn`}>

                        <Button
                            text={buttonComponent?.buttonText}
                            isSecondary
                            onClick={() => {
                                if (buttonComponent?.href && buttonComponent?.href !== "") {
                                    window.open(buttonComponent?.href, '_blank')
                                }
                                else {
                                    setIsOpen(false)
                                    dispatch(setIsComing(true))
                                }
                            }} />
                    </div>}

                </div>
                <div className="Virasat-left-drawer-bottm">
                    <div className="Virasat-left-drawer-bottm-header">
                        ADDRESS
                    </div>
                    <div className="Virasat-left-drawer-bottm-item">
                        13-15, High Street, Staines-Upon-Thames, Surrey, TW18 4QY

                    </div>
                    <div className="Virasat-left-drawer-bottm-item2">
                        P: <b>+44 1784 463978</b>
                    </div>
                    <div className="Virasat-left-drawer-bottm-item2">
                        E: <b>info@virasat.uk</b>
                    </div>
                </div>

            </div>
        </div>
    )
}
export default VirasatLeftDrawer